import React from "react";
import Icons from "../../../../config/images";
import "./serviceSection.css";

// Service Card Component
const ServiceCard = ({ icon, title }) => {
  return (
    <div className="service-card-container-style">
      <img src={icon} className="service-card-inside-icon-style" alt="icon" />
      <span className="service-card-title-text-style">{title}</span>
    </div>
  );
};

const ServiceSection = () => {
  return (
    <section className="service-section-main-container">
     <div className="heading-container">
      <span className="green-line"></span>
      <h4 className="service-section-title-style">What We're Offering to Our Clients</h4>
    </div>
      <p className="service-section-heading-style">
        Real Time Dealing in all Professional IT Solutions & Services
      </p>
      <div className="service-section-card-main-container">
        <ServiceCard icon={Icons.mobileIcon} title="Mobile App Development" />
        <ServiceCard icon={Icons.graphicsIcon} title="UI / UX Designing" />
        <ServiceCard icon={Icons.webIcon} title="Web App Development" />
      </div>
    </section>
  );
};

export default ServiceSection;
